//  import { useEffect, useState } from "react";
//  import api from "../api/axios";
//  import Swal from "sweetalert2";

//  function Dashboard() {
//    const roleName = localStorage.getItem("roleName");
//    const counterId = localStorage.getItem("counterId");
//    const [services, setServices] = useState([]);
//    const [loading, setLoading] = useState(true);
//    const [stats, setStats] = useState({});

//    useEffect(() => {
//      load();
//    });

//    const load = async () => {
//      const totalUser = await api.get("/Dashboard/TotalUser");
//      const totalServices = await api.get("/Dashboard/TotalServices");

//      let reportStats;

//      if (roleName === "Admin") {
//        reportStats = await api.get(`/Token/AllReportStats?roleName=${roleName}`);
//      } else {
//        reportStats = await api.get(
//          `/Token/AllReportStats?counterId=${counterId}&roleName=${roleName}`,
//        );
//      }

//      setStats({
//        totalUser: totalUser.data,
//        totalServices: totalServices.data,
//        report: reportStats.data,
//      });
//    };

//    useEffect(() => {
//      loadServices();
//    }, []);
//    const loadServices = async () => {
//      try {
//        const response = await api.get("/Report/Today");

//        setServices(response.data);
//      } catch (error) {
//        Swal.fire({
//          icon: "error",
//          title: "Error",
//          text: "Unable to load services",
//        });
//      } finally {
//        setLoading(false);
//      }
//    };

//    return (
//      <>
//        {/*  <div className="container mt-1"><h2>Dashboard</h2> */}

//        <div className="row text-center" hidden={roleName === "Counter"}>
//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              Today's Total Token
//              <h2>{stats.report?.todayTotal}</h2>
//            </div>
//          </div>

//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              {/* Pending */}
//              {/* Waiting
//            <h2>{stats.pending}</h2> */}
//              Today's Token Waiting
//              {stats.report?.todayPending > 0 ? (
//                <h2>{stats.report?.todayPending}</h2>
//              ) : (
//                <h2>0</h2>
//              )}
//            </div>
//          </div>

//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              Today's Token Completed
//              <h2>{stats.report?.todayCompleted}</h2>
//            </div>
//          </div>

//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              Today's Token Skipped
//              <h2>{stats.report?.todaySkipped}</h2>
//            </div>
//          </div>
//        </div>

//        <div className="row text-center">
//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              Total Token
//              <h2>{stats.report?.overallTotal}</h2>
//            </div>
//          </div>

//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              {/* Pending */}
//              {/* Waiting
//            <h2>{stats.pending}</h2> */}
//              Total Token Waiting
//              {stats.report?.overallPending > 0 ? (
//                <h2>{stats.report?.overallPending}</h2>
//              ) : (
//                <h2>0</h2>
//              )}
//            </div>
//          </div>

//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              Total Token Completed
//              <h2>{stats.report?.overallCompleted}</h2>
//            </div>
//          </div>

//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              Total Token Skipped
//              <h2>{stats.report?.overallSkipped}</h2>
//            </div>
//          </div>
//        </div>

//        <div className="row text-center" hidden={roleName === "Counter"}>
//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              Total User
//              <h2>{stats.totalUser}</h2>
//            </div>
//          </div>

//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              {/* Pending */}
//              {/* Waiting
//            <h2>{stats.pending}</h2> */}
//              Total Counter
//              {stats.pending > 0 ? <h2>{stats.pending}</h2> : <h2>0</h2>}
//            </div>
//          </div>

//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              Total Services
//              <h2>{stats.totalServices}</h2>
//            </div>
//          </div>

//          <div className="col-md-3 col-6 p-1">
//            <div className="card p-3">
//              Total Status
//              <h2>{stats.Status > 0 ? <>{stats.Status}</> : <>0</>}</h2>
//            </div>
//          </div>
//        </div>

//        <div className="row text-center py-4" hidden={roleName === "Counter"}>
//          {loading ? (
//            <div className="text-center">Loading...</div>
//          ) : (
//            <div className="table-responsive">
//              <table className="table table-bordered table-striped">
//                <thead className="table-dark">
//                  <tr>
//                    {/* <th>ID</th> */}
//                    <th>Counter ID</th>
//                    <th className="bg-warning">Waiting</th>
//                    <th className="bg-info">Serving</th>
//                    <th className="bg-primary">Skipped</th>
//                    <th className="bg-success">Completed</th>
//                    <th className="bg-danger">Total</th>
//                    {/* <th>Status</th> */}
//                  </tr>
//                </thead>

//                <tbody>
//                  {services.length > 0 ? (
//                    services.map((item) => (
//                      <tr key={item.id}>
//                        {/* <td>{item.id}</td> */}
//                        <td>
//                          {item.counterId} {item.serviceName}
//                        </td>
//                        <th className="text-warning">{item.waiting}</th>
//                        <th className="text-info">{item.serving}</th>
//                        <th className="text-primary">{item.skipped}</th>
//                        <th className="text-success">{item.completed}</th>
//                        <th className="text-danger">{item.total}</th>
//                        {/* <td>{item.isActive ? "Active" : "Inactive"}</td> */}
//                      </tr>
//                    ))
//                  ) : (
//                    <tr>
//                      <td colSpan="8" className="text-center">
//                        No Record Found
//                      </td>
//                    </tr>
//                  )}
//                </tbody>
//              </table>
//            </div>
//          )}
//        </div>
//      </>
//    );
//  }

//  export default Dashboard;

// import { useEffect, useState } from "react";
// import api from "../api/axios";
// import Swal from "sweetalert2";

// function Dashboard() {
//   const roleName = localStorage.getItem("roleName");
//   const counterId = localStorage.getItem("counterId");

//   const [services, setServices] = useState([]);
//   const [stats, setStats] = useState({});
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadDashboard();
//   }, []);

//   const loadDashboard = async () => {
//     setLoading(true);

//     try {
//       const reportRequest =
//         roleName === "Admin" || roleName === "Company"
//           ? api.get(`/Token/AllReportStats?roleName=${roleName}`)
//           : api.get(
//               `/Token/AllReportStats?counterId=${counterId}&roleName=${roleName}`,
//             );

//       const [totalUser, totalServices, reportStats, todayReport] =
//         await Promise.all([
//           api.get("/Dashboard/TotalUser"),
//           api.get("/Dashboard/TotalServices"),
//           reportRequest,
//           api.get("/Report/Today"),
//         ]);

//       setStats({
//         totalUser: totalUser.data,
//         totalServices: totalServices.data,
//         report: reportStats.data,
//       });

//       setServices(todayReport.data);
//     } catch (error) {
//       console.error(error);

//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: error.response?.data?.message || "Unable to load dashboard.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

import { useCallback, useEffect, useState } from "react";
import api from "../api/axios";
 import Swal from "sweetalert2";
 
function Dashboard() {
  const roleName = localStorage.getItem("roleName");
  const counterId = localStorage.getItem("counterId");

  const [services, setServices] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  const loadDashboard = useCallback(async () => {
    setLoading(true);

    try {
      const reportRequest =
        roleName === "Admin" || roleName === "Company"
          ? api.get(`/Token/AllReportStats?roleName=${roleName}`)
          : api.get(
              `/Token/AllReportStats?counterId=${counterId}&roleName=${roleName}`
            );

      const [totalUser, totalServices, reportStats, todayReport] =
        await Promise.all([
          api.get("/Dashboard/TotalUser"),
          api.get("/Dashboard/TotalServices"),
          reportRequest,
          api.get("/Report/Today"),
        ]);

      setStats({
        totalUser: totalUser.data,
        totalServices: totalServices.data,
        report: reportStats.data,
      });

      setServices(todayReport.data);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Unable to load dashboard.",
      });
    } finally {
      setLoading(false);
    }
  }, [roleName, counterId]);

  useEffect(() => {
    loadDashboard();
  }, [loadDashboard]);

  // ...



  return (
    <>
      {/*  <div className="container mt-1"><h2>Dashboard</h2> */}

      <div className="row text-center" hidden={roleName === "Counter"}>
        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            <h6 class="text-primary">Today's Total Token</h6>
            <h2>{stats.report?.todayTotal}</h2>
          </div>
        </div>

        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            {/* Pending */}
            {/* Waiting
           <h2>{stats.pending}</h2> */}
            <h6 class="text-warning">Today's Token Waiting</h6>
            {stats.report?.todayPending > 0 ? (
              <h2>{stats.report?.todayPending}</h2>
            ) : (
              <h2>0</h2>
            )}
          </div>
        </div>

        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            <h6 class="text-info">Today's Token Skipped</h6>
            <h2>{stats.report?.todaySkipped}</h2>
          </div>
        </div>

        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            <h6 class="text-success">Today's Token Completed</h6>
            <h2>{stats.report?.todayCompleted}</h2>
          </div>
        </div>
      </div>

      <div className="row text-center">
        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
        Total Token
            <h2>{stats.report?.overallTotal}</h2>
          </div>
        </div>

        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            {/* Pending */}
            {/* Waiting
           <h2>{stats.pending}</h2> */}
            Total Token Waiting
            {stats.report?.overallPending > 0 ? (
              <h2>{stats.report?.overallPending}</h2>
            ) : (
              <h2>0</h2>
            )}
          </div>
        </div>

            <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            Total Token Skipped
            <h2>{stats.report?.overallSkipped}</h2>
          </div>
        </div>

        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            Total Token Completed
            <h2>{stats.report?.overallCompleted}</h2>
          </div>
        </div>

    
      </div>

      <div className="row text-center" hidden={roleName === "Counter"}>
        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            Total User
            <h2>{stats.totalUser}</h2>
          </div>
        </div>

        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            {/* Pending */}
            {/* Waiting
           <h2>{stats.pending}</h2> */}
            Total Counter
            {stats.pending > 0 ? <h2>{stats.pending}</h2> : <h2>0</h2>}
          </div>
        </div>

        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            Total Services
            <h2>{stats.totalServices}</h2>
          </div>
        </div>

        <div className="col-md-3 col-6 p-1">
          <div className="card p-3">
            Total Status
            <h2>{stats.Status > 0 ? <>{stats.Status}</> : <>0</>}</h2>
          </div>
        </div>
      </div>

      <div className="row text-center py-4" hidden={roleName === "Counter"}>
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  {/* <th>ID</th> */}
                  <th>Counter ID</th>
                  <th className="bg-warning bg-secondary">Waiting</th>
                  <th className="bg-secondary">Serving</th>
                  <th className="bg-info">Skipped</th>
                  <th className="bg-olive">Completed</th>
                  <th className="bg-success">Total</th>
                  {/* <th>Status</th> */}
                </tr>
              </thead>

              <tbody>
                {services.length > 0 ? (
                  services.map((item) => (
                    <tr key={item.id}>
                      {/* <td>{item.id}</td> */}
                      <td>
                        {item.counterId} {item.serviceName}
                      </td>
                      <td className="text-warning">{item.waiting}</td>
                      <td className="text-secondary">{item.serving}</td>
                      <td className="text-info">{item.skipped}</td>
                      <td className="text-olive">{item.completed}</td>
                      <td className="text-success">{item.total}</td>
                      {/* <td>{item.isActive ? "Active" : "Inactive"}</td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}

export default Dashboard;
